module.exports = __webpack_public_path__ + "media/success01.7c201ce7.mp3";